<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回"
        :back-link-url="`/acceptance/list/${
          this.acceptance.projectId}?name=${this.$f7route.query.name || ''}`">
      </f7-nav-left>
      <f7-nav-title>{{ this.$f7route.query.name }}</f7-nav-title>
      <f7-nav-right v-if="acceptance.canCancel">
        <div @click="cancelApply">取消申请</div>
      </f7-nav-right>
    </f7-navbar>
    <div :class="hackClass">
      <div class="accept-title">{{acceptance.title}}</div>
      <div class="accept-status">
        <div class="accept-date">
          验收通过日期： {{ acceptance.acceptanceFinishedTime | formatDateValue }}
        </div>
        <div class="accept-date">
          报验数量： {{ acceptance.acceptanceCount || '' }}
        </div>
        <div class="accept-title-finished" v-if="acceptance.finished === '1'">完工验收</div>
        <div class="accept-title-building" v-else>进度验工</div>
      </div>
      <div>
        <p>{{ acceptance.remark }}</p>
      </div>
      <div @click="browserPhoto(acceptance.attachmentList)">
        <f7-swiper id="acceptanceInfo" :params="{
          speed:500, slidesPerView: 4, spaceBetween: 10,
          observer: true, observeParents: true}">
          <f7-swiper-slide v-for="attach in acceptance.attachmentList" :key="attach">
            <img :src="imageUrl+'?attachmentId='+attach" style="width: 100%; height: 100%;"/>
          </f7-swiper-slide>
        </f7-swiper>
      </div>
      <div class="timeline" style="padding: 0rem 0rem;">
        <div class="timeline-item"
          v-for="approve in acceptance.acceptanceApproveVoList"
          :key="approve.id"
          style="align-items: center;">
          <div class="timeline-item-date" style="width: 5rem; padding-top: 0.2rem;">
            {{ approve.approveTime | formatDateValue }}
          </div>
          <div class="timeline-item-divider custom-divider">
            <div class="divider-icon-check" v-if="approve.result === 'agree'">
              <f7-icon fa="check-circle" size="1.75rem"></f7-icon>
            </div>
            <div class="divider-icon-close" v-if="approve.result === 'reject'">
              <f7-icon fa="times-circle" size="1.75rem"></f7-icon>
            </div>
          </div>
          <div class="timeline-item-content" style="padding-top: 0.2rem;">
            {{ approve.acceptanceItemDesc }} {{ approve.resultDesc }} {{ approve.approveIdDesc }}
            <div class="approve-score" v-if="approve.remark && approve.remark !== ''">
              <div class="reject-remark">验收说明：{{ approve.remark }}</div>
            </div>
            <div class="approve-score" v-else>
              <div class="reject-remark" style=""></div>
            </div>
            <div class="approve-score" v-if="approve.star">
              <div v-if="approve.acceptanceItem === 'composite'">文明施工：</div>
              <div v-else>{{ approve.acceptanceItemDesc }}：</div>
              <div
                class="approve-score-star"
                v-for="item in scoreList"
                :key="item">
                <f7-icon
                  size="1.2rem"
                  :fa="item <= approve.star ? 'star' : 'star-o'">
                </f7-icon>
              </div>
            </div>
            <div
              class="approve-score"
              v-if="approve.result === 'agree' && approve.acceptanceItem === 'composite'">
              <div>任务进度：</div>
              <div
                class="approve-score-star"
                v-for="item in scoreList"
                :key="item">
                <f7-icon
                  size="1.2rem"
                  :fa="item <= approve.progressStar ? 'star' : 'star-o'">
                </f7-icon>
              </div>
            </div>
            <div @click="browserPhoto(approve.attachmentList)">
              <f7-swiper :params="{
                speed:500, slidesPerView: 3, spaceBetween: 6,
                observer: true, observeParents: true}">
                <f7-swiper-slide v-for="ia in approve.attachmentList" :key="ia">
                  <img :src="imageUrl+'?attachmentId='+ia" style="width: 100%; height: 100%;"/>
                </f7-swiper-slide>
              </f7-swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </f7-page>
</template>
<script>
import { dateFormat } from '@/util/dateUtils';
import { imageView } from '@/api/common';
import { getAcceptance, cancelAcceptance } from '@/api/acceptance';
import { createToast } from '@/util/compUtils';

export default {
  props: ['applyId'],
  data() {
    return {
      imageUrl: imageView,
      acceptance: {},
      scoreList: [1, 2, 3, 4, 5],
      title: '',
      hackClass: '',
    };
  },
  mounted() {
    this.geInfo();
  },
  watch: {
    'acceptance.id': function idChg() {
      this.hackClass = 'has-content';
    },
  },
  filters: {
    formatDateValue: value => dateFormat(value, 'YYYY-MM-DD HH:mm'),
  },

  methods: {
    geInfo() {
      const projectId = this.$f7route.query.projectId;
      const params = { applyId: this.applyId, projectId };
      getAcceptance(params).then((result) => {
        if (result.code === 0) {
          this.acceptance = result.data || {};
        }
      });
    },
    cancelApply() {
      this.$f7.dialog.confirm('确认要取消验收申请吗？', '温馨提示', () => {
        const projectId = this.$f7route.query.projectId || '';
        const name = this.$f7route.query.name || '';
        const params = { applyId: this.applyId, projectId };
        cancelAcceptance(params).then((result) => {
          if (result.code === 0) {
            createToast(this, '取消成功');
            this.$f7router.back(`/acceptance/list/${projectId}?name=${name}`);
          }
        });
      });
    },
    browserPhoto(itemArr) {
      this.$f7.photoBrowser.create({
        photos: (itemArr || []).map(item => `${this.imageUrl}?attachmentId=${item}`),
        backLinkText: '返回',
        navbarOfText: '/',
        iconsColor: 'white',
        routableModals: false,
      }).open();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .accept-title {
    text-align: center;
    border-bottom: 0.05rem solid $border-color;
    padding-bottom: 1rem;
  }

  .accept-status {
    display: flex;
    padding-top: 1rem;
  }

  .accept-date {
    flex: auto;
    font-size: 0.7rem;
    color: $second-font-color;
    height: 1.5rem;
    line-height: 1.5rem;
  }

  @mixin accept-title-status($bgColor, $color) {
    background-color: $bgColor;
    color: $color;
    border-radius: 0.8rem;
    padding: 0rem 0.8rem;
    height: 1.5rem;
    line-height: 1.5rem;
    font-size: 0.6rem;
  }

  .accept-title-finished {
    @include accept-title-status(#F8F8F8, #2F8811);
  }

  .accept-title-building {
    @include accept-title-status(#F8F8F8, #FFA000);
  }

  .custom-divider {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
  }

  .divider-icon-check {
    width: 100%;
    height: 100%;
    background-color: $white-color;
    color: #80C269;
  }

  .divider-icon-close {
    width: 100%;
    height: 100%;
    background-color: $white-color;
    color: #E60012;
  }

  .reject-remark {
    margin-left: 0rem;
    width: 12rem;
    color: #999999;
    font-size: 0.6rem;
  }

  .approve-score {
    display: flex;
    margin: 0.5rem 0rem;
    color: #999999;
  }

  .approve-score-star {
    cursor: pointer;
    padding: 0rem 0.25rem;
    color: #FF9403;
  }

</style>



// WEBPACK FOOTER //
// src/pages/acceptance/info.vue